export default "__VITE_ASSET__BDSlmshD__"